import { render, staticRenderFns } from "./ModalAlterarDatas.vue?vue&type=template&id=7a54ed10"
import script from "./ModalAlterarDatas.vue?vue&type=script&lang=ts"
export * from "./ModalAlterarDatas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports